var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M129.042,127.228l5.077-5.077a1.284,1.284,0,0,0-1.814-1.817l-5.077,5.077-5.077-5.077a1.285,1.285,0,0,0-1.817,1.817l5.077,5.077-5.077,5.077a1.285,1.285,0,1,0,1.817,1.817l5.077-5.077,5.077,5.077a1.285,1.285,0,1,0,1.817-1.817Z",
    transform: "translate(-116.228 -116.228)",
    fill: "#de3618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectCrossIcon);
export default __webpack_public_path__ + "static/media/MultiselectCross-icon.7249e47df8bdb872d68513e8dbd3d522.svg";
export { ForwardRef as ReactComponent };